import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";

export default function ScreenDonSection({context, campagneData}){

    const [loading, setLoading] = useState(true)
    const [dons, setDons] = useState([])

    const formater = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 })

    const partnerMontant = campagneData?.partnerMontant || 1
    const screenOptions = campagneData?.screenOptions || {}

    const getDisplayName = (campagneExtraData = {}) => {
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons = async () => {
        let url = "/campagne/donors/" + campagneData.id
        const res = await ApiService.get(url)
        let _dons = res.data

        if(screenOptions.minMontant){
            _dons = _dons.filter(i => i.montant >= screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    const visibleDons = loading ? [] : dons.slice(0, 4)

    const cardHeight = "calc(21vw * 9 / 16)"

    return (
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", padding:"0 4vw", minHeight: cardHeight}}>
            <div style={{
                width:"100%",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"row-reverse",
                gap:"2vw",
                minHeight: cardHeight,
            }}>
                {visibleDons.map((d) => {
                    const displayName = getDisplayName(d.campagneExtraData)
                    const amount = formater.format(d.montant / partnerMontant)
                    const donorLabel = context.getDonorName(amount)

                    return (
                        <div key={d.id} className="csaclay-don-card csaclay-fade-in">
                            <span className="csaclay-don-name">{displayName}</span>
                            <span className="csaclay-don-amount">{amount} Par.</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
